module.exports = __webpack_public_path__ + "static/img/step-2-image-2.9924aa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/faqNew/img/step-2-image-2.png
// module id = cuet
// module chunks = 1